import { TeamMember, Volunteer } from '../types/team';
import { colors } from '../styles/theme';

export const teamMembers: TeamMember[] = [
  {
    name: "Emmanuel MILLIOT",
    role: "President",
    description: "Student in communication technology",
    image: "https://i.imgur.com/ydnoG9D.png",
    linkedin: "https://www.linkedin.com/in/emmanuelmilliot/",
    instagram: "http://instagram.com/emmanuelmilliot/",
    mail: "mailto:emmanuel@europeanstudent.org",
    color: colors.primary
  },
  {
    name: "Logan VINH-SAN",
    role: "Vice President",
    description: "Student in systems and networks for businesses",
    image: "https://i.imgur.com/73BJXsQ.png",
    linkedin: "https://www.linkedin.com/in/logan-vinh-san-09b530225/",
    instagram: "http://instagram.com/logan.vhsn/",
    mail: "mailto:logan@europeanstudent.org",
    color: colors.primary
  }
];

export const volunteers: Volunteer[] = [
  {
    name: "Valentin MENES",
    role: "Communication Manager",
    image: "https://i.imgur.com/9XZSrdB.png",
    linkedin: "#",
    instagram: "#",
    mail: "#",
    color: colors.primary,
  }
];
